import { render, staticRenderFns } from "./preOrderClass.vue?vue&type=template&id=1933de31&scoped=true"
import script from "./preOrderClass.vue?vue&type=script&lang=js"
export * from "./preOrderClass.vue?vue&type=script&lang=js"
import style0 from "./preOrderClass.vue?vue&type=style&index=0&id=1933de31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933de31",
  null
  
)

export default component.exports